import { ITagRepository } from 'domain/repositories/Tag'

export const fetchTagsByCampaignId =
  (repo: ITagRepository) => async (campaignId: string) => {
    const list = await repo.fetchByCampaignId(campaignId)
    return list
  }
